import React, { useState, useEffect, use } from 'react';
import './Solver.css';
import CloseIcon from '@mui/icons-material/Close';
import { Button, Grid2 } from "@mui/material";
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid2';
import SolverSettings from './SolverSettings'
import Snackbar from '@mui/material/Snackbar';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Slide from '@mui/material/Slide';
import Grow from '@mui/material/Grow';
import RefreshIcon from '@mui/icons-material/Refresh';


function Solver(props) {

    const [data, setData] = useState({
        week: 0,
        distribution: null,
        distributionSplits: null,
        vertical: 'bottom',
        horizontal: 'center',
        copiedNotification: false,
        modified: false
    })

    const { vertical, horizontal, copiedNotification } = data;
    const playerList = props.players
    var settings = structuredClone(props.static.settings)
    const piecesList = ['weapon', 'head', 'body', 'hands', 'legs', 'feet', 'ears', 'neck', 'wrists', 'ring']
    const pieces = ['weapon', 'head', 'body', 'hands', 'legs', 'feet', 'ears', 'neck', 'wrists', 'ring', 'shine', 'twine']
    const gear = ['weapon', 'head', 'body', 'hands', 'legs', 'feet', 'ears', 'neck', 'wrists', 'fingerL', 'fingerR']
    const sides = [['weapon', 'head', 'body', 'hands', 'legs', 'feet'], ['ears', 'neck', 'wrists', 'fingerL', 'fingerR']]
    const containerRef = React.useRef(null);
    const weeks = [0, 1, 2, 3, 4, 5, 6, 7]


    function buildBasicPrioList(players) {
        var prio = [];
        settings.basicLootPriority.forEach(role => {
            prio.push(getPlayersByRole(role, players))
        });
        return prio;
    }

    function buildBasicPrioListAlts(players) {
        var prio = [];
        for (let i = 0; i < 3; i++) {
            var group = [];
            players.forEach((player) => {
                if (player.alts[i]) {
                    player.alts[i].name = player.name;
                    player.alts[i].playerID = player.playerID;
                    group.push(player.alts[i]);
                }
            })
            prio.push(group);
        }
        return prio;
    }

    // builds priority list based on points -> lower gets loot first.
    // This function is for groups where equal distribution is desired within a group
    // Points calculation: # acquired - # needed + (group index * 10)
    // Piece distribution will go from least needed first to most needed.
    // rerun after each piece distributed
    function buildPiecePriorityWithinGroups(prioList, gearPiece) {
        var piecePrio = []
        for (let i = 0; i < prioList.length; i++) {
            var flatAmount = i * 100;
            prioList[i].forEach((player) => {
                var points = 0;
                if (gearPiece !== 'shine' && gearPiece !== 'twine') {
                    if (player.neededGear[gearPiece] != 'raid' || gearPiece === 'weapon' || player.acquiredGear[gearPiece] == true)
                        return;
                    points = player.raidAcquired - player.raidNeeded + flatAmount;
                }
                else if ((gearPiece === 'shine' && player.shinesNeeded !== player.shinesAcquired)) {
                    points = player.shinesAcquired - player.shinesNeeded + flatAmount
                }
                else if ((gearPiece === 'twine' && player.twinesNeeded !== player.twinesAcquired))
                    points = player.twinesAcquired - player.twinesNeeded + flatAmount
                else {
                    return
                }

                piecePrio.push([player.playerID, points, i])
            })
        }
        piecePrio.sort(function (a, b) { return (a[1] - b[1]) })
        return piecePrio;
    }


    function buildPieceDistributionList(players) {
        var piecesPrio = []
        pieces.forEach(piece => {
            piecesPrio.push([piece, totalNeeded(piece, players)])
        })
        piecesPrio.sort(function (a, b) { return (a[1] - b[1]) })
        return piecesPrio;
    }

    function totalNeeded(gearPiece, players) {
        var count = 0;
        players.forEach(player => {
            if (player.neededGear[gearPiece] === 'raid' && player.acquiredGear[gearPiece] === false)
                count++;
            else if (gearPiece === 'twine' && player.twinesNeeded > player.twinesAcquired)
                count += (player.shinesNeeded - player.shinesAcquired)
            else if (gearPiece === 'shine' && player.shinesNeeded > player.shinesAcquired)
                count += (player.shinesNeeded - player.shinesAcquired)
        })
        return count;
    }

    function getPlayersByRole(role, players) {
        var playerList = []
        players.some((selectedPlayer) => {
            if (role == selectedPlayer.role) {
                playerList.push(selectedPlayer);
            }
        })
        return playerList;
    }

    function processPlayerList(players) {
        players.forEach((player) => {
            processPlayer(player);
            if (settings.alts) {
                player.alts.forEach((alt) => {
                    processPlayer(alt)
                })
            }
        })
    }

    function processPlayer(player) {
        var raidAcquired = 0;
        var shinesAcquired = 0;
        var twinesAcquired = 0;
        var raidNeeded = 0;
        var shinesNeeded = 0;
        var twinesNeeded = 0;
        gear.forEach((gearPiece) => {
            if (player.neededGear[gearPiece] == 'raid') {
                raidNeeded++;
                if (player.acquiredGear[gearPiece])
                    raidAcquired++;
            }
            if (player.neededGear[gearPiece] == 'tome') {
                if (sides[0].includes(gearPiece) && gearPiece != 'weapon') {
                    twinesNeeded++;
                    if (player.augmented[gearPiece])
                        twinesAcquired++;
                }
                if (sides[1].includes(gearPiece)) {
                    shinesNeeded++;
                    if (player.augmented[gearPiece])
                        shinesAcquired++;
                }
            }
        })
        player['raidAcquired'] = raidAcquired;
        player['shinesAcquired'] = shinesAcquired;
        player['twinesAcquired'] = twinesAcquired;
        player['raidNeeded'] = raidNeeded;
        player['shinesNeeded'] = shinesNeeded;
        player['twinesNeeded'] = twinesNeeded;

        if (player.neededGear['fingerL'] == 'raid' || player.neededGear['fingerR'] == 'raid')
            player.neededGear['ring'] = 'raid';
        else {
            player.neededGear['ring'] = 'tome';
        }
        if ((player.acquiredGear['fingerL'] == true && player.neededGear['fingerL'] == 'raid') || (player.acquiredGear['fingerR'] == true && player.neededGear['fingerR'] == 'raid'))
            player.acquiredGear['ring'] = true;
        else {
            player.acquiredGear['ring'] = false;
        }
    }

    function runSolver(players, numberOfWeeks) {
        var weeklyDistribution = []
        var prioList = buildBasicPrioList(players);
        var prioListAlts = buildBasicPrioListAlts(players);
        var piecesPrioList = buildPieceDistributionList(players);
        for (let i = 0; i < numberOfWeeks; i++) {
            //per week
            var distribution = {};
            piecesPrioList.forEach(gearPiece => {
                var piecePrio;
                if (settings.augmentEnabled && (gearPiece[0] === 'twine' || gearPiece[0] === 'shine')) {
                    if (settings.equalAugments) {
                        var flatprioList = [prioList.flat()]
                        piecePrio = buildPiecePriorityWithinGroups(flatprioList, gearPiece[0])
                    }
                    else {
                        piecePrio = buildPiecePriorityWithinGroups(prioList, gearPiece[0])
                    }
                }
                else {
                    if (settings.equalDistribution)
                        prioList = [prioList.flat()]
                    piecePrio = buildPiecePriorityWithinGroups(prioList, gearPiece[0])
                }
                if (!piecePrio[0]) {
                    if (settings.alts) {
                        piecePrio = buildPiecePriorityWithinGroups(prioListAlts, gearPiece[0])

                        if (!piecePrio[0]) {
                            if (gearPiece[0] === 'weapon') {
                                distribution[gearPiece[0]] = { name: 'TBD', job: 'FFA', alt: false }
                            }
                            else {
                                distribution[gearPiece[0]] = { name: 'FFA', job: 'FFA', alt: false }
                            }
                        }

                        else {
                            var player = players.filter(obj => {
                                return obj.playerID === piecePrio[0][0]
                            })[0].alts[piecePrio[0][2]]
                            if (gearPiece[0] === 'shine') {
                                player.shinesAcquired += 1
                            }
                            else if (gearPiece[0] === 'twine') {
                                player.twinesAcquired += 1
                            }
                            else {
                                player.acquiredGear[gearPiece[0]] = true;
                                player.raidAcquired += 1;
                            }
                            distribution[gearPiece[0]] = { name: player.name, job: player.job, alt: true };
                        }
                    }
                    else {
                        if (gearPiece[0] === 'weapon') {
                            distribution[gearPiece[0]] = { name: 'TBD', job: 'FFA', alt: false }
                        }
                        else {
                            distribution[gearPiece[0]] = { name: 'FFA', job: 'FFA', alt: false }
                        }
                    }

                }

                //assign gearpiece
                else {
                    var player = players.filter(obj => {
                        return obj.playerID === piecePrio[0][0]
                    })[0]
                    if (gearPiece[0] === 'shine') {
                        player.shinesAcquired += 1
                    }
                    else if (gearPiece[0] === 'twine') {
                        player.twinesAcquired += 1
                    }
                    else {
                        player.acquiredGear[gearPiece[0]] = true;
                        player.raidAcquired += 1;
                    }
                    distribution[gearPiece[0]] = { name: player.name, job: player.job, alt: false };
                }
            })
            weeklyDistribution.push(distribution)
        }
        return weeklyDistribution;
    }

    function solver(numberOfWeeks) {

        var players = structuredClone(playerList)
        processPlayerList(players);
        if (!settings.advanced) {
            if (!settings.splits) {
                var weeklyDistribution = runSolver(players, numberOfWeeks)
                setData({ ...data, distribution: weeklyDistribution });
            }
            else {
                var g1 = [];
                var g2 = [];
                players.forEach((player) => {
                    if (settings.g1.indexOf(player.playerID) != -1)
                        g1.push(player);
                    else if (settings.g2.indexOf(player.playerID) != -1)
                        g2.push(player)
                })
                var weeklyDistribution = runSolver(g1, numberOfWeeks)
                var weeklyDistributionSplits = runSolver(g2, numberOfWeeks)
                setData({ ...data, distribution: weeklyDistribution, distributionSplits: weeklyDistributionSplits });
            }

        }
    }

    function closeMenu() {
        props.closeMenu('table');
    }

    function updateStatic(_static) {
        props.updateStatic(_static);
        settings = _static.settings;
        rerender();
    }

    function normalizeName(player) {
        var name = player.name;
        if (!player.name)
            return
        if (player.name.length > 12)
            name = `${player.name.substring(0, 9)}...`;
        if (player.alt)
            name += ' (Alt)'

        return name;
    }

    function getPlayers(group) {
        var playerIDs;
        if (group === 'g1')
            playerIDs = settings.g1;
        if (group === 'g2')
            playerIDs = settings.g2;
        var players = '(';
        playerIDs.forEach((playerID) => {
            players += `${playerList[playerID].name}, `;
        })
        players = players.substring(0, players.length - 2);
        players += ')';
        return players;
    }

    function renderResults() {
        return (
            <div>
                <div style={{ height: '120px' }}>
                    {settings.splits ? <div>
                        <div style={{ fontSize: '24px' }}>Group 1</div>
                        <div style={{ fontSize: '12px' }}>{getPlayers('g1')}</div>
                    </div> : null}
                    {weeks.map(week =>
                        <div key={week} style={{ justifyContent: 'center', display: 'flex', whiteSpace: 'nowrap' }} className='distrib-container-wrapper'>
                            <div className='distrib-container'>
                                {data.week == week ?
                                    <Grid container spacing={6}>
                                        <Grid size={3} >
                                            <div className="floor">
                                                First Floor:
                                            </div>
                                            <div className="loot-distrib">
                                                Ears: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distribution[data.week].ears.job}.png`)} /> {normalizeName(data.distribution[data.week].ears)}
                                            </div >
                                            <div className="loot-distrib">
                                                Neck: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distribution[data.week].neck.job}.png`)} /> {normalizeName(data.distribution[data.week].neck)}
                                            </div>
                                            <div className="loot-distrib">
                                                Wrists: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distribution[data.week].wrists.job}.png`)} /> {normalizeName(data.distribution[data.week].wrists)}
                                            </div>
                                            <div className="loot-distrib">
                                                Ring: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distribution[data.week].ring.job}.png`)} /> {normalizeName(data.distribution[data.week].ring)}
                                            </div>
                                        </Grid>
                                        <Grid size={3}>
                                            <div className="floor">
                                                Second Floor:
                                            </div>
                                            <div className="loot-distrib">
                                                Head: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distribution[data.week].head.job}.png`)} /> {normalizeName(data.distribution[data.week].head)}
                                            </div >
                                            <div className="loot-distrib">
                                                Hands: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distribution[data.week].hands.job}.png`)} /> {normalizeName(data.distribution[data.week].hands)}
                                            </div>
                                            <div className="loot-distrib">
                                                Feet: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distribution[data.week].feet.job}.png`)} /> {normalizeName(data.distribution[data.week].feet)}
                                            </div>
                                            <div className="loot-distrib">
                                                Shine: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distribution[data.week].shine.job}.png`)} /> {normalizeName(data.distribution[data.week].shine)}
                                            </div>
                                        </Grid>
                                        <Grid size={3}>
                                            <div className="floor">
                                                Third Floor:
                                            </div>
                                            <div className="loot-distrib">
                                                Body: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distribution[data.week].body.job}.png`)} />{normalizeName(data.distribution[data.week].body)}
                                            </div >
                                            <div className="loot-distrib">
                                                Legs: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distribution[data.week].legs.job}.png`)} />{normalizeName(data.distribution[data.week].legs)}
                                            </div>
                                            <div className="loot-distrib">
                                                Twine: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distribution[data.week].twine.job}.png`)} />{normalizeName(data.distribution[data.week].twine)}
                                            </div>
                                        </Grid>
                                        <Grid size={3}>
                                            <div className="floor">
                                                Fourth Floor:
                                            </div>
                                            <div className="loot-distrib">
                                                Weapon: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distribution[data.week].weapon.job}.png`)} />{normalizeName(data.distribution[data.week].weapon)}
                                            </div >
                                        </Grid>

                                    </Grid>
                                    : null}
                            </div>
                        </div>)}

                </div>

                {settings.splits ? <div style={{ height: '120px', marginTop: '80px', marginBottom: '60px' }}>
                    <hr style={{ width: '80%', height: '1px', border: 0, borderTop: '2px solid #737373' }} />
                    <div>
                        <div style={{ fontSize: '24px' }}>Group 2</div>
                        <div style={{ fontSize: '12px' }}>{getPlayers('g2')}</div>
                    </div>
                    {weeks.map(week =>
                        <div key={`${week}split`} style={{ justifyContent: 'center', display: 'flex', whiteSpace: 'nowrap' }} >
                            <div className='distrib-container'>
                                {data.week == week ?
                                    <Grid container spacing={6}>
                                        <Grid size={3}>
                                            <div className="floor">
                                                First Floor:
                                            </div>
                                            <div className="loot-distrib">
                                                Ears: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distributionSplits[data.week].ears.job}.png`)} />{normalizeName(data.distributionSplits[data.week].ears)}
                                            </div >
                                            <div className="loot-distrib">
                                                Neck: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distributionSplits[data.week].neck.job}.png`)} />{normalizeName(data.distributionSplits[data.week].neck)}
                                            </div>
                                            <div className="loot-distrib">
                                                Wrists: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distributionSplits[data.week].wrists.job}.png`)} />{normalizeName(data.distributionSplits[data.week].wrists)}
                                            </div>
                                            <div className="loot-distrib">
                                                Ring: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distributionSplits[data.week].ring.job}.png`)} />{normalizeName(data.distributionSplits[data.week].ring)}
                                            </div>
                                        </Grid>
                                        <Grid size={3}>
                                            <div className="floor">
                                                Second Floor:
                                            </div>
                                            <div className="loot-distrib">
                                                Head: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distributionSplits[data.week].head.job}.png`)} />{normalizeName(data.distributionSplits[data.week].head)}
                                            </div >
                                            <div className="loot-distrib">
                                                Hands: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distributionSplits[data.week].hands.job}.png`)} />{normalizeName(data.distributionSplits[data.week].hands)}
                                            </div>
                                            <div className="loot-distrib">
                                                Feet: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distributionSplits[data.week].feet.job}.png`)} />{normalizeName(data.distributionSplits[data.week].feet)}
                                            </div>
                                            <div className="loot-distrib">
                                                Shine: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distributionSplits[data.week].shine.job}.png`)} />{normalizeName(data.distributionSplits[data.week].shine)}
                                            </div>
                                        </Grid>
                                        <Grid size={3}>
                                            <div className="floor">
                                                Third Floor:
                                            </div>
                                            <div className="loot-distrib">
                                                Body: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distributionSplits[data.week].body.job}.png`)} />{normalizeName(data.distributionSplits[data.week].body)}
                                            </div >
                                            <div className="loot-distrib">
                                                Legs: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distributionSplits[data.week].legs.job}.png`)} />{normalizeName(data.distributionSplits[data.week].legs)}
                                            </div>
                                            <div className="loot-distrib">
                                                Twine: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distributionSplits[data.week].twine.job}.png`)} />{normalizeName(data.distributionSplits[data.week].twine)}
                                            </div>
                                        </Grid>
                                        <Grid size={3}>
                                            <div className="floor">
                                                Fourth Floor:
                                            </div>
                                            <div className="loot-distrib">
                                                Weapon: <img className='job-icon' src={require(`../FFXIVIcons/JOBS/${data.distributionSplits[data.week].weapon.job}.png`)} />{normalizeName(data.distributionSplits[data.week].weapon)}
                                            </div >
                                        </Grid>

                                    </Grid>
                                    : null}
                            </div>
                        </div>)}

                </div> : null}
            </div>

        )
    }

    function rerender() {
        solver(8);
    }

    function copyToClipboard() {
        var text = `# ${data.week == 0 ? "Current week" : "Week " + (data.week + 1)} loot distribution: \n`

        if (settings.splits) {
            text += `# __Group 1__: 
-# ${getPlayers('g1')}\n`
        }

        text += `## First Floor: 
Ears: ${data.distribution[data.week].ears.name} (${data.distribution[data.week].ears.job}${data.distribution[data.week].ears.alt ? ' - Alt' : ''})
Neck: ${data.distribution[data.week].neck.name} (${data.distribution[data.week].neck.job}${data.distribution[data.week].neck.alt ? ' - Alt' : ''})
Wrists: ${data.distribution[data.week].wrists.name} (${data.distribution[data.week].wrists.job}${data.distribution[data.week].wrists.alt ? ' - Alt' : ''})
Ring: ${data.distribution[data.week].ring.name} (${data.distribution[data.week].ring.job}${data.distribution[data.week].ring.alt ? ' - Alt' : ''})
## Second Floor: 
Head: ${data.distribution[data.week].head.name} (${data.distribution[data.week].head.job}${data.distribution[data.week].head.alt ? ' - Alt' : ''})
Hands: ${data.distribution[data.week].hands.name} (${data.distribution[data.week].hands.job}${data.distribution[data.week].hands.alt ? ' - Alt' : ''})
Feet: ${data.distribution[data.week].feet.name} (${data.distribution[data.week].feet.job}${data.distribution[data.week].feet.alt ? ' - Alt' : ''})
Shine: ${data.distribution[data.week].shine.name} (${data.distribution[data.week].shine.job}${data.distribution[data.week].shine.alt ? ' - Alt' : ''})
## Third Floor: 
Body: ${data.distribution[data.week].body.name} (${data.distribution[data.week].body.job}${data.distribution[data.week].body.alt ? ' - Alt' : ''})
Legs: ${data.distribution[data.week].legs.name} (${data.distribution[data.week].legs.job}${data.distribution[data.week].legs.alt ? ' - Alt' : ''})
Twine: ${data.distribution[data.week].twine.name} (${data.distribution[data.week].twine.job}${data.distribution[data.week].twine.alt ? ' - Alt' : ''})
## Fourth Floor: 
Weapon: ${data.distribution[data.week].weapon.name} (${data.distribution[data.week].weapon.job}${data.distribution[data.week].weapon.alts ? ' - Alt' : ''})
`
        if (settings.splits) {
            text += `## ▃▃▃▃▃▃▃▃▃▃▃▃▃▃▃▃▃▃▃
# __Group 2__: 
-# ${getPlayers('g2')}
## First Floor: 
Ears: ${data.distributionSplits[data.week].ears.name} (${data.distributionSplits[data.week].ears.job}${data.distributionSplits[data.week].ears.alt ? ' - Alt' : ''})
Neck: ${data.distributionSplits[data.week].neck.name} (${data.distributionSplits[data.week].neck.job}${data.distributionSplits[data.week].neck.alt ? ' - Alt' : ''})
Wrists: ${data.distributionSplits[data.week].wrists.name} (${data.distributionSplits[data.week].wrists.job}${data.distributionSplits[data.week].wrists.alt ? ' - Alt' : ''})
Ring: ${data.distributionSplits[data.week].ring.name} (${data.distributionSplits[data.week].ring.job}${data.distributionSplits[data.week].ring.alt ? ' - Alt' : ''})
## Second Floor: 
Head: ${data.distributionSplits[data.week].head.name} (${data.distributionSplits[data.week].head.job}${data.distributionSplits[data.week].head.alt ? ' - Alt' : ''})
Hands: ${data.distributionSplits[data.week].hands.name} (${data.distributionSplits[data.week].hands.job}${data.distributionSplits[data.week].hands.alt ? ' - Alt' : ''})
Feet: ${data.distributionSplits[data.week].feet.name} (${data.distributionSplits[data.week].feet.job}${data.distributionSplits[data.week].feet.alt ? ' - Alt' : ''})
Shine: ${data.distributionSplits[data.week].shine.name} (${data.distributionSplits[data.week].shine.job}${data.distributionSplits[data.week].shine.alt ? ' - Alt' : ''})
## Third Floor: 
Body: ${data.distributionSplits[data.week].body.name} (${data.distributionSplits[data.week].body.job}${data.distributionSplits[data.week].body.alt ? ' - Alt' : ''})
Legs: ${data.distributionSplits[data.week].legs.name} (${data.distributionSplits[data.week].legs.job}${data.distributionSplits[data.week].legs.alt ? ' - Alt' : ''})
Twine: ${data.distributionSplits[data.week].twine.name} (${data.distributionSplits[data.week].twine.job}${data.distributionSplits[data.week].twine.alt ? ' - Alt' : ''})
## Fourth Floor: 
Weapon: ${data.distributionSplits[data.week].weapon.name} (${data.distributionSplits[data.week].weapon.job}${data.distributionSplits[data.week].weapon.alt ? ' - Alt' : ''})
`
        }
        navigator.clipboard.writeText(text)
        setData({ ...data, copiedNotification: true })
    }

    function handleClose() {
        setData({ ...data, copiedNotification: false })
    }

    function keyPressWeek(e) {
        if (e.key == 'Enter') {
            gotoWeek();
        }
    }

    function gotoWeek() {
        var week = document.getElementById('week').value;
        if (week < 1) {
            document.getElementById('week').value = 1;
            week = 1;
        }
        else if (week > 8) {
            document.getElementById('week').value = 8;
            week = 8;
        }
        setData({ ...data, week: week - 1 })
    }

    function minusOneWeek() {
        setData({ ...data, week: data.week - 1 })
        document.getElementById('week').value = data.week;
    }

    function plusOneWeek() {
        setData({ ...data, week: data.week + 1 })
        document.getElementById('week').value = data.week + 2;
    }

    useEffect(() => {
        if (props.menu === 'calc')
            rerender();
    }, [props])



    return (
        <div className='outerdiv1' style={{ marginTop: '50px' }}>
            <div className='innerdivborder1'>
                <div className='innerdiv1' >
                    <div><Button className='close-btn' variant="contained" onClick={closeMenu}><CloseIcon style={{ color: '#fad99a' }} /></Button> </div>
                    {/*<div >
                        <Button className='refresh-btn' variant="contained" onClick={rerender}><RefreshIcon style={{ color: '#fad99a' }} />
                        </Button>
                    </div>*/}
                    <div className='enabled-settings-container'>
                        <div>
                            Enabled Settings:
                        </div>
                        <div className='enabled-settings'>
                            {settings.alts ? <div>-Alts before FFA</div> : <div>-No alts</div>}
                            {settings.equalDistribution ? <div>-Equal Distribution</div> : <div>-DPS→Tanks→Healers</div>}
                            {settings.splits ? <div>-Splits</div> : null}
                            {settings.augmentEnabled ? <div> {settings.equalAugments ? <div>-Separate Augments (equal) </div> : <div>-Separate Augments (dps first)</div>} </div> : null}
                        </div>
                    </div>
                    <div className='enabled-settings'></div>
                    <div style={{ fontSize: '36px' }}>Loot Distribution Solver (WIP)</div>
                    <div>Attempts loot distribution based on criteria</div>
                    <div style={{ fontSize: '12px' }}>Note: This does not include book usage.</div>
                    {/*<div style={{ fontSize: '12px' }}>*If something seems incorrect, make sure all changes are saved and then hit the refresh solver button.</div>*/}
                    <SolverSettings static={props.static} updateStatic={updateStatic} players={props.players} />
                    <div style={{ fontSize: '24px' }}>
                        Week {data.week + 1}
                    </div>
                    <div style={{ fontSize: '12px' }}>(Calculated from today)</div>
                    <div style={{ justifyContent: 'center', display: 'flex' }}>
                        <div style={{ width: '15%', marginTop: '10px', marginBottom: '10px' }}>
                            <Grid container>
                                <Grid size={3}>
                                    <Button className='navigation' variant="contained" onClick={minusOneWeek} disabled={data.week < 1}><ChevronLeftIcon style={{ color: '#fad99a' }} /></Button>
                                </Grid>
                                <Grid size={6}>
                                    <TextField
                                        id='week' variant="standard" type="tel" name="week" defaultValue={data.week + 1}
                                        sx={{ input: { color: 'aliceblue', borderBottom: "2px solid #ffffff", textAlign: 'center', fontSize: '14px' }, label: { color: 'aliceblue' }, width: '8ch' }}
                                        onKeyDown={(e) => keyPressWeek(e)} onBlur={gotoWeek}
                                    />
                                </Grid>
                                <Grid size={3}>
                                    <Button className='navigation' variant="contained" onClick={plusOneWeek} disabled={data.week > 6}><ChevronRightIcon style={{ color: '#fad99a' }} /></Button>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                    <div>
                        {data.distribution ? renderResults() : null}
                    </div>
                    <div><Button className='copy' variant="contained" onClick={copyToClipboard}>Copy to clipboard<ContentCopyIcon style={{ color: '#fad99a', marginLeft: '5px', marginRight: '-5px' }} /></Button> </div>
                </div>
            </div>
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={copiedNotification}
                autoHideDuration={2000}
                onClose={handleClose}
                message={
                    <div><CheckCircleIcon style={{ width: '20px', color: '#56d36a' }} /><div style={{ float: "right", margin: '5px' }}>Copied text for week {data.week + 1}</div></div>
                }
            />
        </div>
    );
}

export default Solver;